// extracted by mini-css-extract-plugin
export var option = "_d2-0";
export var optionCard = "_d2-f";
export var optionContent = "_d2-g";
export var optionIcon = "_d2-i";
export var optionIconBox = "_d2-h";
export var optionLabel = "_d2-j";
export var optionPill = "_d2-m";
export var optionPillBadge = "_d2-p";
export var optionPillIcon = "_d2-n";
export var optionPillLabel = "_d2-o";
export var optionRadio = "_d2-k";
export var optionRadioInner = "_d2-l";
export var optionReveal = "_d2-2";
export var optionRevealDelay0 = "_d2-3";
export var optionRevealDelay1 = "_d2-4";
export var optionRevealDelay10 = "_d2-d";
export var optionRevealDelay11 = "_d2-e";
export var optionRevealDelay2 = "_d2-5";
export var optionRevealDelay3 = "_d2-6";
export var optionRevealDelay4 = "_d2-7";
export var optionRevealDelay5 = "_d2-8";
export var optionRevealDelay6 = "_d2-9";
export var optionRevealDelay7 = "_d2-a";
export var optionRevealDelay8 = "_d2-b";
export var optionRevealDelay9 = "_d2-c";
export var optionSelected = "_d2-1";